module.exports = __webpack_public_path__ + "static/img/og-level.df5c3809.png";